<template>
  <label
    >Cobertura comunicacional
    <i
      class="fa fa-info-circle text-primary"
      title="Señale la cobertura comunicacional requerida para su evento y que podrá ser cubierta por UNICOM"
    ></i
  ></label>

  <div class="row">
    <div class="col-md-6">
      <div class="mb-3">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="requests.requireBanner"
            id="requireBanner"
          />
          <label class="form-check-label" for="requireBanner"> Banner </label>
        </div>

        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="requests.requirePoster"
            id="requirePoster"
          />
          <label class="form-check-label" for="requirePoster"> Afiche </label>
        </div>

        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="requests.requireSocialMedia"
            id="requireSocialMedia"
          />
          <label class="form-check-label" for="requireSocialMedia">
            Redes sociales
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            v-model="requests.requirePrensa"
            id="requirePrensa"
          />
          <label class="form-check-label" for="requirePrensa">
            Cobertura de prensa
          </label>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="requests.requireLiveStream"
          id="requireLiveStream"
        />
        <label class="form-check-label" for="requireLiveStream">
          Transmisión en vivo
        </label>
      </div>

      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="requests.isWebinar"
          id="isWebinar"
        />
        <label class="form-check-label" for="isWebinar">
          Es webinar
          <span
            ><i
              class="fa fa-info-circle"
              title="Deberá procederse a la grabación del mismo"
            ></i
          ></span>
        </label>
      </div>

      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="requests.requirePhotoOrVideo"
          id="requirePhotoOrVideo"
        />
        <label class="form-check-label" for="requirePhotoOrVideo">
          Fotografía/video del evento
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UnicomRequests",
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      requests: {
        requireBanner: false,
        requirePoster: false,
        requireSocialMedia: false,
        requirePrensa: false,
        requireLiveStream: false,
        isWebinar: false,
        requirePhotoOrVideo: false,
      },
    };
  },
  watch: {
    requests: {
      deep: true,
      handler(newVal) {
        const converted = {};
        for (const key in newVal) {
          converted[key] = newVal[key] ? 1 : 0;
        }
        this.$emit("update:modelValue", converted);
      },
    },
    modelValue: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (!newVal) return;
        for (const key in this.requests) {
          this.requests[key] =
            newVal[key] === 1 || newVal[key] === true ? true : false;
        }
      },
    },
  },
};
</script>
